<template>
  <div class="page">
    <summary-header />
    <v-container class="contents">
      <v-row
        class=""
        dense>
        <v-col>
          <v-card
            tile
            elevation="0">
            <div class="d-flex">
              <div class="section-title">
                + Career
                <span class="text-caption"></span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <table class="tbl">
              <thead>
                <tr>
                  <th class="text-left title-cell">
                    <div style="">연도</div>
                  </th>
                  <th
                    class="text-center"
                    v-for="y in years[0]"
                    :key="y">
                    <div>
                      {{ (y - years[0][0]) % 2 === 0 ? `'${y.toString().substr(2, 2)}` : '' }}
                    </div>
                  </th>
                </tr>
                <tr class="exit-row">
                  <th class="text-center title-cell">
                    <div class="col-header">
                      <span style="">경력</span>
                    </div>
                  </th>
                  <th
                    class="text-center header-cell"
                    v-for="(y, n) in years[1]"
                    :key="y">
                    <div :class="[n === 0 ? 'start-row' : '', n === years[1].length - 1 ? 'end-row' : '']">{{ (y - years[1][0]) % 2 === 0 ? y : '' }}</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(kk, i) in careerCell"
                  :key="kk + i + 'km'"
                  class="career-row">
                  <td class="text-left title-cell">
                    <div class="">
                      {{ i + 1 + '번째 커리어' }}
                      <br />
                      <span class="text-body-2">{{ kk[0] }}</span>
                    </div>
                  </td>
                  <td
                    v-for="(l, j) in kk.slice(1)"
                    :key="l + i + j"
                    :class="['text-center']"
                    :colspan="l.split(/:/).length > 1 ? l.split(/:/)[1] : 1">
                    <div :class="[l.split(/:/).length > 1 ? 'start-row end-row content-cell caption py-1' : '']">
                      {{ l.split(/:/)[0] }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-card
            tile
            flat>
            <div class="d-flex">
              <div class="section-title">근속기간 만족도</div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pa-0">
              <v-list dense>
                <v-list-item
                  v-for="(v, i) in career['커리어-이력'].value"
                  :key="'p' + i"
                  style="border-bottom: 1px solid lightGrey; min-height: 20px; padding: 0px">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-left caption">{{ `${v.team} (${v.jobTitle})` }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content style="max-width: 32px">
                    <v-list-item-title class="text-center">
                      <span class="font-weight-bold secondary--text">{{ v.seq === 0 ? 2020 - v.year : career['커리어-이력'].value[i - 1].year - v.year }} 년</span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content style="max-width: 32px">
                    <v-list-item-title class="text-right">{{ v.score }}점</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card
            tile
            flat>
            <div class="d-flex">
              <div class="section-title">
                가장 잘하는 강점목록
                <span class="text-caption"></span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <div class="pt-2">
              <v-chip
                small
                label
                class="ma-1 px-2 white--text font-weight-bold"
                color="#1c5eaa"
                v-for="(v, i) in career['커리어-강점목록'].value"
                :key="'s' + i">
                {{ v }}
              </v-chip>
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card
            tile
            flat>
            <div class="d-flex">
              <div class="section-title">
                가장 뛰어난 역량
                <span class="text-caption"></span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <div class="pt-2">
              <v-chip
                small
                label
                class="ma-1 px-2 white--text font-weight-bold"
                color="#1c5eaa"
                v-for="(v, i) in career['커리어-역량목록'].value"
                :key="'s' + i">
                {{ v }}
              </v-chip>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card
            tile
            flat>
            <div class="d-flex">
              <div class="section-title">
                꾼
                <span class="text-caption">전문성</span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pa-0">
              <v-list dense>
                <v-list-item
                  v-for="(v, i) in career['커리어-평생자산-전문성'].value.slice(0, 6)"
                  :key="'pp' + i"
                  style="border-bottom: 1px solid lightGrey; min-height: 20px; padding: 0px">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-left caption">{{ `${v.unit}` }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content style="">
                    <v-list-item-title class="text-right">
                      <span class="font-weight-bold secondary--text">{{ v.value || '-' }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            tile
            flat>
            <div class="d-flex">
              <div class="section-title">
                꿈
                <span class="text-caption">관심영역</span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pa-0">
              <v-list dense>
                <v-list-item
                  v-for="(v, i) in career['커리어-평생자산-관심흥미'].value.slice(0, 6)"
                  :key="'pj' + i"
                  style="border-bottom: 1px solid lightGrey; min-height: 20px; padding: 0px">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-left caption">{{ `${v.unit}` }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content style="">
                    <v-list-item-title class="text-right">
                      <span class="font-weight-bold secondary--text">{{ v.value || '-' }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            tile
            flat>
            <div class="d-flex">
              <div class="section-title">
                끈
                <span class="text-caption">관계자원</span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pa-0">
              <v-list dense>
                <v-list-item
                  v-for="(v, i) in career['커리어-평생자산-관계자원'].value.slice(0, 6)"
                  :key="'pl' + i"
                  style="border-bottom: 1px solid lightGrey; min-height: 20px; padding: 0px">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-left caption">{{ `${v.unit}` }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content style="">
                    <v-list-item-title class="text-right">
                      <span class="font-weight-bold secondary--text">{{ v.value || '-' }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            tile
            flat>
            <div class="d-flex">
              <div class="section-title">
                생애 이슈
                <span class="text-caption"></span>
              </div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pa-0">
              <v-list dense>
                <v-list-item
                  v-for="(v, i) in getIssue"
                  :key="'pk' + i"
                  style="border-bottom: 1px solid lightGrey; min-height: 20px; padding: 0px">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-left caption">{{ `${v.q}` }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content style="">
                    <v-list-item-title class="text-right">
                      <span class="font-weight-bold secondary--text">{{ v.v || '-' }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row></v-row>
      <v-row></v-row>
    </v-container>
    <v-footer
      padless
      color="transparent">
      <v-col class="text-center pa-0">
        <span class="caption">&copy;삼성금융경력컨설팅센터</span>
      </v-col>
    </v-footer>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapMutations, mapState, mapGetters } from 'vuex'
import SummaryHeader from './SummaryHeader.vue'
export default {
  components: { SummaryHeader },
  name: 'Career',
  data() {
    return {
      lifeIssueText: ['현재 ~ 퇴직시점?', '국민연금 수령시점?', '국면연금 수령이후?', '그외 기타 재무이슈는?'],
      icon: {
        Finance: 'mdi-finance',
        Master: 'mdi-telegram',
        Career: 'mdi-briefcase',
        Life: 'mdi-home-city-outline',
      },
      관계: 'mdi-handshake',
      커리어: 'mdi-briefcase',
      건강: 'mdi-hospital-box',
      재무: 'mdi-cash-usd-outline',
      cashFlow: [],
      opt: {
        grid: {
          width: '80%',
          left: '18%',
          hegith: '100%',
        },
      },
    }
  },
  computed: {
    ...mapState(['master', 'me', 'wife', 'children', 'parents', 'finance', 'currentYear', 'housePension', 'career']),
    ...mapGetters(['getExit', 'getFinanceGoalMoney']),

    getIssue() {
      return [
        {
          q: '일로부터의 은퇴 나이는?',
          v: this.career['커리어-완전은퇴']?.value + '세',
        },
        {
          q: '은퇴 후 고려하는 직업은?',
          v: this.career['커리어-퇴근후직업']?.value
            .map((k) => k.value)
            .filter((k) => k)
            .join(', '),
        },
        {
          q: '경력개발을 위해 하고싶은 것?',
          v: this.career['커리어-경력개발']?.value
            .map((k) => k.value)
            .filter((k) => k)
            .join(', '),
        },
      ]
    },
    years() {
      const k = _.sortBy(this.career['커리어-이력']?.value, ['year'], ['desc'])
      const length = this.currentYear - Number(k[0].year)
      const l = [...Array.from(new Array(length))].map((o, i) => this.currentYear - i).reverse()
      return [l, l.map((o) => o - this.currentYear)]
    },
    careerYear() {
      let endYear = '3000'
      const k = this.career['커리어-이력']?.value.map((o) => {
        const r = this.years[0].map((yr) => (yr <= endYear && o.year < yr ? o.jobTitle : ''))
        endYear = o.year

        // return [o.jobTitle].concat(r)
        return [o.team].concat(r)
      })
      return k
    },
    getColor() {
      const colorDefinition = {
        Things: 'Red-#EA202C',
        People: 'Green-#66B032',
        Think: 'Yellow-#FDED2A',
        Idea: 'Blue-#1258DC',
      }

      return colorDefinition[this.career['커리어-선호활동'].list[0].title].split(/-/)
    },
    getInterest() {
      const colorDefinition = {
        활동적: 'R',
        진취적: 'E',
        예술적: 'C',
        사교적: 'A',
        모범적: 'S',
        학구적: 'I',
      }
      return `${colorDefinition[this.career['커리어-선호흥미'].list[0].title] + colorDefinition[this.career['커리어-선호흥미'].list[1].title]}`
    },

    //[["대표직무","","","","","","","","","","","대표직무:10"],["대표직무2","대표직무2:10","","","","","","","","","",""]]
    //[["ff","ff","ff","ff","ff","ff","ff","ff","ff","ff","ff","ff","ff","ff","ff","ff"]]
    careerCell() {
      const cy = this.careerYear
      const cyk = cy.map((c) => {
        const team = c[0]
        const rest = c.slice(0)
        const arr = []
        let title = ''
        let cnt = 0
        rest.forEach((k) => {
          if (k === team) arr.push(k)
          else if (k === '') {
            arr.push(k)
          } else {
            if (cnt === 0) {
              arr.push(k + ':')
              title = k
            }
            cnt++
          }
          // if (k === title) arr.push(k)
          // else if (k === '') {
          //   arr.push(k)
          // } else {
          //   if (cnt === 0) {
          //     arr.push(k + ':')
          //     team = k
          //   }
          //   cnt++
          // }
        })
        const idx = arr.indexOf(title + ':')
        arr[idx] = title + ':' + cnt
        // const idx = arr.indexOf(team + ':')
        // arr[idx] = team + ':' + cnt
        return arr
      })
      return cyk
    },
  },
  methods: {
    ...mapMutations([]),
    getImg(event) {
      if (event === '정년') return '/images/retire.svg'
      if (event === '연금') return '/images/pension.svg'
      if (event === '결혼') return '/images/marry.svg'
      if (event === '상배') return '/images/solo.svg'
      if (event === '근속') return '/images/work.svg'
      if (event === '임피') return '/images/salary.svg'
      if (event === '취직') return '/images/job.svg'
      if (event === '가료') return '/images/care.svg'
    },
  },
}
</script>

<style
  lang="scss"
  scoped>
.summary-name {
  position: absolute;
  left: 40px;
  top: 200px;
}
.page {
  position: relative;
  border: 1px solid white;
  // width: 2480px;
  // height: 3508px;
  width: 21cm;
  height: 29.7cm;
  margin: auto;
  page-break-before: always;

  // @media print {
  //   body {
  //     width: 21cm;
  //     height: 29.7cm;
  //     margin: 30mm 45mm 30mm 45mm;
  //     /* change the margins as you want them to be. */
  //   }
  // }
  .contents {
    // border-top: 1px solid black;
    margin-top: 30px;
    height: 1070px - 30px;
    padding: 0 40px;

    .section-title {
      padding-top: 0px;
      font-weight: 900;
      font-size: 18px;
      height: 18px;
      color: #1c5eaa;
      font-family: 'SamsungSans';
    }
    .section-title-border {
      height: 20px;
      margin-left: 10px;
      flex-grow: 1;
      border-bottom: 1px solid #165caa;
    }
    .ans {
      // height: 30px;
      color: black;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 라인수 */
      -webkit-box-orient: vertical;
      white-space: normal;
      line-height: 1.2em;
      max-height: 3.6em;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .listing div.v-list-item__subtitle {
      font-size: 16px !important;
    }
    .listing div.v-list-item__title {
      font-size: 18px !important;
    }
    .listing div.v-list-item > div {
      line-height: 18px !important;
    }
    .bottom-border {
      border-bottom: 1px solid grey;
    }
    table.tbl {
      border-collapse: collapse !important;
      table-layout: fixed;
      word-break: break-all;
      width: 100%;

      thead tr {
        height: 30px;
        font-weight: bold;
        font-size: 14px;
      }
      tr:nth-of-type(2n) {
        // background: #f7cac9;
      }
      tr.age-row > td {
        font-size: 12px !important;
        font-weight: 600;
      }
      div.content-cell {
        line-height: 20px;
        background-color: #70cae9;
        color: white;
        width: 100%;
        height: 20px;
      }
      div.content-border {
        border-radius: 25px 25px 25px 25px;
      }

      div.pension-start {
        border-radius: 5px 45% 45% 5px;
      }
      div.start-row {
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;
      }
      div.end-row {
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;
      }
      tr.career-row {
        height: 50px;
        line-height: 35px;
        border-bottom: 1px solid grey;

        td.title-cell {
          div {
            height: 40px;
          }
        }
        div {
          height: 30px;
          line-height: 20px;
          vertical-align: center;
          padding: 0 5px;
        }
      }
      tr.exit-row {
        height: 32px;
        font-size: 12px;
        font-weight: 600;
        border-bottom: 1px solid black;
        border-top: 1px solid black;

        div {
          background: grey;
          color: white;
          width: 100%;
          padding-top: 4px;
          line-height: 14px;
          height: 24px;
        }
        div.col-header {
          text-align: left;
          width: 90%;
          border-radius: 0 25px 25px 0;
          background: grey;
          color: white;
        }
      }
      th,
      td :not(.title-cell) {
        white-space: nowrap;
        word-break: break-all;
        // border: 1px solid grey;
      }
      th.title-cell {
        overflow-wrap: break-word;
        font-size: 14px;
        line-height: 25px;
        font-weight: 600;
        div {
          padding: 5px;
        }
      }
      td.title-cell {
        overflow-wrap: break-word;
        font-size: 14px;
        line-height: 25px;
        font-weight: 600;
      }

      td.event {
        // border-left: 2px solid #9b1b30; //#9b1b30;
        // font-weight: 600;
        // color: white;
        // background-color: #2a4b7c; //rgba(182, 51, 50,0.5);
      }
      .title-cell {
        min-width: 110px !important;
        // width: 4%;
        width: 110px;

        // background-color: #2a4b7c;
        // color: white;
      }
      td.minus {
        font-weight: 600;
        color: white;
        background-color: #9b1b30;
      }
    }
    .score {
      padding: 18px;
    }
    .life-top {
      font-size: 1em;
      border-bottom: 2px solid black;
    }
    .header-col {
      border-right: 1px solid black;
    }
    .life {
      text-align: center;
      min-height: 64px;
    }
    .life-footer {
    }
    // .echarts {
    //   width: 100%;
    //   height: 100%;
    // }
    .echarts {
      height: 480px;
      width: 100%;
    }
    .good {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-right: 1px solid grey;
    }
    .bad {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-right: 1px solid grey;
    }
    .happy-row {
      border-top: 1px solid grey;
    }
  }
  .footer {
    border-bottom: 1px solid grey;
    display: flex;
    align-items: flex-end;
    span {
      display: inline-block;
    }
  }
}
</style>
